import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'UnattendedProcess/GetUnattendedProcessTypes', method: 'GET', body: null, token: token })
}
